/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseReturnRequisitionInterface {
  "id"?: number;
}

export class ERPpurchaseReturnRequisition implements ERPpurchaseReturnRequisitionInterface {
  "id": number;
  constructor(data?: ERPpurchaseReturnRequisitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseReturnRequisition`.
   */
  public static getModelName() {
    return "ERPpurchaseReturnRequisition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseReturnRequisition for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseReturnRequisitionInterface): ERPpurchaseReturnRequisition{
    return new ERPpurchaseReturnRequisition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseReturnRequisition',
      plural: 'ERPpurchaseReturnRequisitions',
      path: 'ERPpurchaseReturnRequisitions',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseReturnRequisition.ts